import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 24px;
  background: #f5f5f5;
  gap: 16px;
  overflow-y: auto;
  overflow-x: hidden;

  @media (max-width: 960px) {
    height: auto;
    padding: 16px;
  }

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const LoadingOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(245, 245, 245, 0.65);
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const ActionsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ActionButton = styled.button<{
  variant: "primary" | "secondary";
  color: string;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 42px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid
    ${({ variant, color }) => (variant === "primary" ? color : "#d0d5dd")};
  background: ${({ variant, color }) =>
    variant === "primary" ? color : "#ffffff"};
  color: ${({ variant }) => (variant === "primary" ? "#ffffff" : "#344054")};
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  i {
    font-size: 12px;
  }
`;

export const ViewDropdownWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const ViewTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  padding: 0 14px;
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  background: #ffffff;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;

export const ViewMenu = styled.div`
  display: flex;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 10px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
  z-index: 1000;
  flex-direction: column;
  width: 180px;
  gap: 8px;
`;

export const ContentLayout = styled.div`
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const SideColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
`;

export const SideCard = styled.div`
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 18px;
  padding: 18px;
`;

export const MiniCalendarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 14px;
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 600;
  color: #344054;
`;

export const MiniNavGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const MiniNavButton = styled.button`
  width: 28px;
  height: 28px;
  border: 1px solid #d0d5dd;
  border-radius: 999px;
  background: #ffffff;
  color: #344054;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
  }
`;

export const MiniWeekRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
  margin-bottom: 8px;
`;

export const MiniWeekLabel = styled.div`
  text-align: center;
  font-size: 10px;
  font-weight: 600;
  color: #98a2b3;
  text-transform: uppercase;
`;

export const MiniDaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  gap: 4px;
`;

export const MiniDayButton = styled.button<{
  isCurrentMonth: boolean;
  isSelected: boolean;
  isToday: boolean;
}>`
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  border: 0;
  border-radius: 999px;
  background: ${({ isSelected, isToday }) =>
    isSelected ? "#e11d48" : isToday ? "#eff6ff" : "transparent"};
  color: ${({ isSelected, isCurrentMonth }) =>
    isSelected ? "#ffffff" : isCurrentMonth ? "#344054" : "#c0c6d1"};
  font-size: 12px;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 500)};
  cursor: pointer;
`;

export const MiniDayDot = styled.span`
  position: absolute;
  left: 50%;
  bottom: 4px;
  width: 6px;
  height: 6px;
  border-radius: 999px;
  background: #7dd3fc;
  transform: translateX(-50%);
`;

export const AgendaTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #344054;
  margin-bottom: 14px;
`;

export const SearchInputWrapper = styled.label`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchInputIcon = styled.i`
  position: absolute;
  left: 12px;
  color: #98a2b3;
  font-size: 14px;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 42px;
  border: 1px solid #eaecf0;
  border-radius: 10px;
  background: #f8f8f8;
  color: #344054;
  font-size: 14px;
  padding: 0 14px 0 36px;
  outline: none;

  &::placeholder {
    color: #98a2b3;
  }

  &:focus {
    border-color: #d0d5dd;
    background: #ffffff;
  }
`;

export const SearchResultsState = styled.div`
  color: #98a2b3;
  font-size: 13px;
  margin-top: 10px;
`;

export const SearchResultsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
`;

export const SearchResultButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px 12px;
  text-align: left;
  cursor: pointer;

  &:hover {
    background: #f8fafc;
    border-color: #d0d5dd;
  }
`;

export const SearchResultTitle = styled.span`
  color: #344054;
  font-size: 13px;
  font-weight: 600;
`;

export const SearchResultMeta = styled.span`
  color: #667085;
  font-size: 12px;
`;

export const AgendaList = styled.div<{ compact?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: ${({ compact }) => (compact ? "200px" : "292px")};
  overflow-y: auto;
  overflow-x: hidden;

  &&::-webkit-scrollbar {
    width: 8px;
    background-color: transparent;
    border-radius: 4px;
  }

  &&::-webkit-scrollbar-thumb {
    background-color: #c1c1c1;
    border-radius: 4px;
  }
`;

export const AgendaItem = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #475467;
  min-width: 0;
`;

export const AgendaCheckbox = styled.input`
  width: 16px;
  height: 16px;
`;

export const AgendaName = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MainColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const CalendarCard = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #dfe3ea;
  border-radius: 18px;
  overflow: hidden;
`;

export const MonthTitle = styled.div`
  padding: 18px 20px;
  border-bottom: 1px solid #e7ebf0;
  font-size: 20px;
  font-weight: 600;
  color: #344054;
  text-transform: capitalize;
`;

export const WeekHeaderRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  border-bottom: 1px solid #e7ebf0;
`;

export const WeekHeaderCell = styled.div`
  padding: 12px 8px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  border-right: 1px solid #eef2f6;

  &:last-of-type {
    border-right: 0;
  }
`;

export const DaysGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  grid-auto-rows: auto;
`;

export const DayCell = styled.div<{
  isCurrentMonth: boolean;
  minHeight?: number;
}>`
  padding: 10px 12px;
  min-height: ${({ minHeight }) => `${minHeight ?? 110}px`};
  border-right: 1px solid #eef2f6;
  border-bottom: 1px solid #eef2f6;
  background: ${({ isCurrentMonth }) =>
    isCurrentMonth ? "#ffffff" : "#f3f4f6"};
  color: ${({ isCurrentMonth }) => (isCurrentMonth ? "#344054" : "#98a2b3")};
  cursor: pointer;

  &:nth-of-type(7n) {
    border-right: 0;
  }
`;

export const MonthAppointments = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const MonthAppointment = styled.div`
  padding: 8px 10px;
  border-left: 3px solid #3b82f6;
  border-radius: 4px;
  background: #eaf2ff;
  color: #1d4ed8;
  font-size: 12px;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;

  strong {
    display: block;
    margin-bottom: 2px;
    font-size: 12px;
    font-weight: 700;
  }

  &:hover {
    filter: brightness(0.98);
  }
`;

export const AppointmentTimeDot = styled.span`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 8px;
  border-radius: 999px;
  background: #2563eb;
  vertical-align: middle;
  flex-shrink: 0;
`;

export const DayNumber = styled.div<{ isToday: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ isToday }) => (isToday ? "#ffffff" : "inherit")};
  background: ${({ isToday }) => (isToday ? "#2563eb" : "transparent")};
`;

export const TimeGridScroller = styled.div`
  overflow: visible;
`;

export const WeekGrid = styled.div`
  display: grid;
  grid-template-columns: 56px repeat(7, minmax(0, 1fr));
  min-width: 0;
`;

export const DayGrid = styled.div`
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  min-width: 0;
`;

export const TimeHeaderCell = styled.div`
  border-right: 1px solid #eef2f6;
  border-bottom: 1px solid #e7ebf0;
  background: #ffffff;
`;

export const WeekDayHeaderCell = styled.div`
  min-height: 58px;
  padding: 10px 12px;
  border-right: 1px solid #eef2f6;
  border-bottom: 1px solid #e7ebf0;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 4px;

  &:last-of-type {
    border-right: 0;
  }
`;

export const WeekDayLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #98a2b3;
  text-transform: uppercase;
`;

export const WeekDayNumber = styled.div<{ isToday: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ isToday }) => (isToday ? "#ffffff" : "#344054")};
  background: ${({ isToday }) => (isToday ? "#e11d48" : "transparent")};
`;

export const TimeLabelCell = styled.div<{ rowHeight?: number }>`
  min-height: ${({ rowHeight }) => `${rowHeight ?? 56}px`};
  padding: 8px 6px;
  border-right: 1px solid #eef2f6;
  border-bottom: 1px solid #eef2f6;
  background: #ffffff;
  color: #98a2b3;
  font-size: 10px;
  font-weight: 600;
  text-align: right;
`;

export const TimeSlotCell = styled.div<{ rowHeight?: number }>`
  position: relative;
  min-height: ${({ rowHeight }) => `${rowHeight ?? 56}px`};
  border-right: 1px solid #eef2f6;
  border-bottom: 1px solid #eef2f6;
  background: #ffffff;
  overflow: visible;
  cursor: pointer;

  &:nth-of-type(8n) {
    border-right: 0;
  }
`;

export const DaySlotCell = styled.div<{ rowHeight?: number }>`
  position: relative;
  min-height: ${({ rowHeight }) => `${rowHeight ?? 56}px`};
  border-bottom: 1px solid #eef2f6;
  background: #ffffff;
  overflow: visible;
  cursor: pointer;
`;

export const TimeAppointment = styled.div`
  position: absolute;
  left: var(--appointment-left, 4px);
  width: var(--appointment-width, calc(100% - 8px));
  top: var(--appointment-top, 4px);
  height: var(--appointment-height, 24px);
  padding: 6px 8px;
  border-left: 3px solid #3b82f6;
  border-radius: 4px;
  background: #eaf2ff;
  color: #1d4ed8;
  font-size: 12px;
  line-height: 1.25;
  min-height: 44px;
  box-sizing: border-box;
  overflow: hidden;
  z-index: 2;
  cursor: pointer;

  strong {
    display: inline-flex;
    align-items: center;
    font-size: 12px;
    font-weight: 700;
    margin-bottom: 2px;
  }

  span {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    filter: brightness(0.98);
  }
`;

export const ViewOption = styled.button<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid ${({ isSelected }) => (isSelected ? "#d5dbe3" : "#e5e7eb")};
  border-radius: 10px;
  background: ${({ isSelected }) => (isSelected ? "#eceff3" : "#f8f9fb")};
  color: #2f3542;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
`;
